import { render, staticRenderFns } from "./AnimadePlaceHolder.vue?vue&type=template&id=7129bf81&scoped=true&"
import script from "./AnimadePlaceHolder.vue?vue&type=script&lang=js&"
export * from "./AnimadePlaceHolder.vue?vue&type=script&lang=js&"
import style0 from "./AnimadePlaceHolder.vue?vue&type=style&index=0&id=7129bf81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129bf81",
  null
  
)

export default component.exports